module.exports = __webpack_public_path__ + "img/download.932fd12d.svg";